/**
 * Pure helpers for mapping a source training session into clone form state.
 */

export function mapManageType(dockerManageType) {
  if (!dockerManageType || dockerManageType === 'aws') {
    return 'cloud';
  }
  if (dockerManageType === 'user') {
    return 'local';
  }
  if (dockerManageType === 'kubernetes') {
    return 'kubernetes';
  }
  return 'cloud';
}

export function getWeightsSessionId(source) {
  const id = source?.params?.trainer_params?.weights_session;
  if (id == null || id === '') {
    return null;
  }
  const numericId = Number(id);
  return Number.isFinite(numericId) && numericId > 0 ? numericId : null;
}

export function shouldUseDefaultWeights(source) {
  return getWeightsSessionId(source) == null;
}

export function getCloneModelParams(source) {
  const modelParams = source?.params?.model_params;
  if (!modelParams || typeof modelParams !== 'object') {
    return {};
  }
  return structuredClone(modelParams);
}

export function buildCloneDatasetFields(source, datasetList) {
  const datasetParams = source?.params?.dataset_params;
  const sourceDatasetId = datasetParams?.dataset_id;
  const datasets = Array.isArray(datasetList) ? datasetList : [];
  const dataset = sourceDatasetId
    ? datasets.find((d) => d.id === sourceDatasetId)
    : null;

  if (!sourceDatasetId || !dataset) {
    return { ok: false, sourceDatasetId };
  }

  let annotationSetId = '';
  if (datasetParams?.annotation_set_id && Array.isArray(dataset.annotation_sets)) {
    const annotationSet = dataset.annotation_sets.find(
      (a) => a.id === datasetParams.annotation_set_id,
    );
    annotationSetId = annotationSet?.id || '';
  }

  return {
    ok: true,
    fields: {
      datasetId: dataset.id,
      tagName: datasetParams?.tag_name || '',
      annotationSetId,
      trainGroupName: datasetParams?.train_group_name || '',
      valGroupName: datasetParams?.val_group_name || '',
    },
  };
}

export function buildCloneStaticFields(source) {
  return {
    name: `${source?.name || 'Session'}-COPY`,
    description: source?.description || '',
    schemaType: source?.model || 'modelpack',
    manageType: mapManageType(source?.docker_task?.manage_type),
    useDefaultWeights: shouldUseDefaultWeights(source),
    weightsSessionId: getWeightsSessionId(source),
  };
}
